import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FormWizardSteps } from 'src/app/models/shared-models';
import { VegWizardDataService } from 'src/app/veg-wizard/services/veg-wizard-data.service';
import { VegWizardStateMachineService } from 'src/app/veg-wizard/services/veg-wizard-state-machine.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateNotifierDetailsGuard implements CanActivate {
  constructor(public vwds: VegWizardDataService,
    public stateMachine: VegWizardStateMachineService,
    public router: Router) {}

  canActivate() {

    const dataState = this.vwds.getWizardDataState();

    const result = this.stateMachine.getNotifierDetailsRouterProperties(dataState);
    const resultForLandHolder = this.stateMachine.getLandHolderDetailsRouterProperties(dataState);

    const isNotifierDetailsRequired = !!this.vwds.getLandholderConfirmationModel()?.areYouAuthorised;

    if(resultForLandHolder.isEnabled && !isNotifierDetailsRequired) {
      console.warn('CanActivateNotifierDetailsGuard - will navigate to Lot/Plan page..');
      this.router.navigate([FormWizardSteps.LotOnPlan]);
      return false;
    }

    if (!result.isEnabled) {
      console.warn('CanActivateNotifierDetailsGuard - Required data does not exist!');
      this.router.navigate([FormWizardSteps.LandHolderConfirmation]);
      return false;
    }

    return result.isEnabled;
  }

}
